import React, { Component } from 'react'
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Form,
  FormGroup,
  FormText,
  Label,
  Input, 
  InputGroup,
  InputGroupAddon,
  Badge,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap"
import classnames from 'classnames'

class CreateUsers extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: 'Create'
    }

    this.toggle - this.toggle.bind(this)
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  render () {
    return (
      <div className='animated fadeIn'>
        <Row>
          <Col xs='12' md='12' className='mb-4' >
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === 'Create'})}
                  onClick={() => {this.toggle('Create')}}
                >
                  Create
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === 'Bulk Add'})}
                  onClick={() => {this.toggle('Bulk Add')}}            
                >
                  Bulk Add
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab} >
              <TabPane tabId='Create'>
                <Form className='form-horizontal'>
                  <FormGroup row>
                    <Col md='2' xs='12'>
                      <Label htmlFor='email-input'>Email</Label>
                    </Col>
                    <Col md='10' xs='12'>
                      <Input 
                        type='email' 
                        id='email-input' 
                        name='email' 
                        placeholder='Unique email address' 
                        onChange={this.props.handleChange}  
                        value={this.props.email}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md='2' xs='12'>
                      <Label htmlFor='display-name-input'>Display Name</Label>
                    </Col>
                    <Col md='10' xs='12'>
                      <Input 
                        type='text' 
                        id='display-name-input' 
                        name='displayName' 
                        placeholder='Name to display' 
                        onChange={this.props.handleChange}  
                        value={this.props.displayName}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md='2' xs='12'>    
                      <Label htmlFor='role-input'>Role</Label>
                    </Col>              
                    <Col md='10' xs='12'>
                      <InputGroup>
                        <Input 
                          type='select' 
                          name='role' 
                          id='role-input' 
                          onChange={this.props.handleChange}
                          value={this.props.role}  
                        >
                          <option>Super Admin</option>
                          <option>Company Admin</option>
                          <option>District Admin</option>
                          <option>School Admin</option>
                          <option>Teacher</option>
                          <option>Student</option>
                        </Input>
                      </InputGroup>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md='2' xs='12'>
                      <Label htmlFor='password-name-input'>Password</Label>
                    </Col>
                    <Col md='10' xs='12'>
                      <Input type='password' 
                        id='password-name-input' 
                        name='password' 
                        placeholder='Password must include capital, lowercase, and number'
                        onChange={this.props.handleChange}
                        value={this.props.password}
                      />
                    </Col>
                  </FormGroup>
                  <Button 
                    type="submit" 
                    size="sm" 
                    color="primary"
                    onClick={this.props.handleClick}
                  >
                    <i className="fa fa-dot-circle-o"></i> Submit
                  </Button>
                </Form>
              </TabPane>
              <TabPane tabId='Bulk Add'>
                <p>Bulk Add Here</p>
              </TabPane>
            </TabContent>


          </Col>
        </Row>

      </div>
    )
  }

}

export default CreateUsers


// WEBPACK FOOTER //
// ./src/components/Users/CreateUsers.js